//export const webUrl = 'http://sever.frp.gie360.com/mms';
export const webUrl = 'http://api.55train.com/mms';
//export const webUrl = 'http://localhost:7002/mms';

//export const screenWebUrl = 'http://sever.frp.gie360.com/screen';
export const screenWebUrl = 'http://api.55train.com/screen';
//export const screenWebUrl = 'http://localhost:7004/screen';

//export const hscreenWebUrl = 'http://hmms.frp.gie360.com/hscreen';
export const hscreenWebUrl = 'http://8.136.150.72/hscreen';
//export const hscreenWebUrl = 'http://localhost:7014/hscreen';

export const hscreenWebUrlM = 'http://47.104.160.220/hscreen';
